import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';

import { Button } from 'components';
import ProgressBar from 'components/ProgressBar/ProgressBar';
import JoinLoyaltyPointsField from 'containers/JoinLoyaltyPointsField/JoinLoyaltyPointsField';
import { actions } from 'coupon-common/src/modules/businessInfo';
import { dispatchAsAsync } from 'coupon-common/src/utils';

import styles from './Step4_JoinLoyaltyPoints.module.scss';

const Step4_JoinLoyaltyPoints = ({
  initialValues,
  onBack,
  onNext,
  currentStep,
  totalSteps,
  setSignUpFlowActive,
  dispatch,
  businessInfo
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const joinLoyaltyPointsProgram = async () => {
    setLoading(true);
    setErrorMessage('');

    try {
      const payload = {
        ...businessInfo,
        has_joined_points_program: true,
      };

      const submitErrors = await dispatchAsAsync(actions.updateInfo(payload), dispatch);

      if (submitErrors) {
        setErrorMessage(submitErrors.message || 'Something went wrong. Please try again.');
      } else {
        setSignUpFlowActive(false);
        onNext && onNext();
      }
    } catch (err) {
      console.error('Step4 error:', err);
      setErrorMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async () => {
    setSignUpFlowActive(false);
  };

  return (
    <div className={styles.formContainer}>
      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} label="Join Loyalty Points Program" />

      <Form
        onSubmit={onSubmit}
        initialValues={businessInfo}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <JoinLoyaltyPointsField />

            {errorMessage && (
              <div style={{ color: 'red', margin: '5px', fontSize: '11px' }}>{errorMessage}</div>
            )}

            <div className={styles.buttonWrapper}>
              {!initialValues?.hideBackButton && (
                <Button type="button" outline onClick={onBack} variant="secondary" disabled={loading}>
                  Back
                </Button>
              )}
              <Button type="submit" outline variant="link" disabled={loading}>
                Maybe later
              </Button>
              <Button onClick={joinLoyaltyPointsProgram} fetching={loading} disabled={loading}>
                Join
              </Button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

Step4_JoinLoyaltyPoints.propTypes = {
  initialValues: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  setSignUpFlowActive: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  businessInfo: PropTypes.object,
};

const mapStateToProps = (state) => ({
  businessInfo: state.businessInfo.data,
});

export default connect(mapStateToProps)(Step4_JoinLoyaltyPoints);
